import React, { useCallback } from "react";
import axios from "axios";
import { useTranslation } from "react-i18next";
import { useContentTranslation } from "@/lib/useContentTranslation";

const API = `${process.env.REACT_APP_BACKEND_URL}/api/shows`;
const cache = new Map(); // `${id}:${lang}` -> Promise<{title, description}>

const fetchShow = (id, lang) => {
  const k = `${id}:${lang}`;
  if (!cache.has(k)) {
    cache.set(k, axios.get(`${API}/${id}/translate`, { params: { lang } })
      .then(({ data }) => ({ title: data.title, description: data.description }))
      .catch((e) => { cache.delete(k); throw e; }));
  }
  return cache.get(k);
};

// Show title/description in the viewer's language (automatic, cached per show).
export const useShowTranslation = (id, title, description = "") => {
  const fetchT = useCallback((lang) => fetchShow(id, lang), [id]);
  return useContentTranslation({ title: title || "", description: description || "" }, fetchT, { auto: !!id, key: id });
};

// Inline translated show title (for chips, lists and search rows).
export const ShowTitle = ({ id, title }) => {
  const { values } = useShowTranslation(id, title);
  return <>{values.title || title}</>;
};

// "From {show}" label with the show title in the viewer's language.
export const FromShow = ({ id, title }) => {
  const { t } = useTranslation();
  const { values } = useShowTranslation(id, title);
  return <>{t("watch.fromShow", { title: values.title || title })}</>;
};

export default ShowTitle;
